import React, { Component } from "react";
import Logo from "../design/img/yaystack-logo.png";

class YaystackNavBar extends Component {
  state = {};
  render() {
    if (this.props.noLogo === true) {
      return (
        <nav className="navbar tabbar center yaystack_return_nav_bar pb-2" />
      );
    }
    return (
      <nav className="navbar tabbar center yaystack_return_nav_bar pb-2">
        <img src={Logo} alt="Yaystack Logo" />
      </nav>
    );
  }
}

export default YaystackNavBar;



// WEBPACK FOOTER //
// ./src/components/yaystackNavBar.jsx